import store from '@/store'
import { ref } from '@vue/composition-api'

export default function storageHelper() {
  // Is Storage MovedOut?
  //

  function isStorageBooked(theStorage) {
    const storage = theStorage

    // Check if storage is reserved
    if (storage.storageReservation === true) {
      return ref(true)
    }

    // Get order items from the dedicated store instead of storage.order_items
    const orderItems = store.getters.orderItemsEntries || []
    
    // Find order items for this storage
    const storageOrderItems = orderItems.filter(orderItem => 
      // eslint-disable-next-line operator-linebreak
      orderItem.storage_id === storage.id ||
      (orderItem.storage && orderItem.storage.id === storage.id))

    // Handle empty order items
    if (storageOrderItems.length === 0) {
      return ref(false)
    }

    // Sort by ID descending to get the most recent order item
    const sortedOrderItems = [...storageOrderItems].sort((a, b) => b.id - a.id)
    const mostRecentOrderItem = sortedOrderItems[0]

    // Check if the most recent order item is still active (no moveOutDate)
    if (mostRecentOrderItem && mostRecentOrderItem.moveOutDate === null) {
      return ref(true)
    }
    return ref(false)
  }

  // Deprecated - use isStorageBooked instead
  function isStorageBookedBack(storage) {
    return isStorageBooked(storage)
  }

  function isStorageRented(storage) {
    return isStorageBooked(storage)
  }

  // function countOfRentedStorages() {
  //   let rentedStorages = 0
  //   store.getters.storageEntries.forEach(storage => {
  //     if (isStorageBooked(storage).value) {
  //       rentedStorages += 1
  //     }
  //   })

  //   return ref(rentedStorages)
  // }

  function countOfRentedStorages() {
    const storages = store.getters.storageEntries || []
    const orderItems = store.getters.orderItemsEntries || []
    
    // Create a Set of storage IDs that have active rentals for performance
    const activeStorageIds = new Set()
    orderItems.forEach(orderItem => {
      if (!orderItem.moveOutDate) {
        if (orderItem.storage_id) {
          activeStorageIds.add(orderItem.storage_id)
        } else if (orderItem.storage && orderItem.storage.id) {
          activeStorageIds.add(orderItem.storage.id)
        }
      }
    })

    // Count storages that are either reserved or have active rentals
    let rentedStorages = 0
    storages.forEach(storage => {
      if (storage.storageReservation === true || activeStorageIds.has(storage.id)) {
        rentedStorages += 1
      }
    })

    return ref(rentedStorages)
  }

  // function countOfNotRentedStorages() {
  //   let notRentedStorages = 0
  //   store.getters.storageEntries.forEach(storage => {
  //     if (!isStorageBooked(storage).value) {
  //       notRentedStorages += 1
  //     }
  //   })

  //   return ref(notRentedStorages)
  // }

  function countOfNotRentedStorages() {
    const storages = store.getters.storageEntries || []
    const orderItems = store.getters.orderItemsEntries || []
    
    // Create a Set of storage IDs that have active rentals for performance
    const activeStorageIds = new Set()
    orderItems.forEach(orderItem => {
      if (!orderItem.moveOutDate) {
        if (orderItem.storage_id) {
          activeStorageIds.add(orderItem.storage_id)
        } else if (orderItem.storage && orderItem.storage.id) {
          activeStorageIds.add(orderItem.storage.id)
        }
      }
    })

    // Count storages that are neither reserved nor have active rentals
    let notRentedStorages = 0
    storages.forEach(storage => {
      if (storage.storageReservation !== true && !activeStorageIds.has(storage.id)) {
        notRentedStorages += 1
      }
    })

    return ref(notRentedStorages)
  }

  function countOfRentedStoragesinLocation(location) {
    // console.log(location.storages)

    let rentedStoragesinLocation = 0
    store.getters.getAllStorageFromLocationId(location.id).forEach(storage => {
      if (isStorageBooked(storage).value) {
        rentedStoragesinLocation += 1
      }
    })

    return ref(rentedStoragesinLocation)
  }

  function countOfNotRentedStoragesinLocation(location) {
    // console.log(location.storages)
    let notRentedStoragesinLocation = 0
    store.getters.getAllStorageFromLocationId(location.id).forEach(storage => {
      if (!isStorageBooked(storage).value) {
        notRentedStoragesinLocation += 1
      }
    })

    return ref(notRentedStoragesinLocation)
  }

  // get StorageSumPrice
  function getStorageSumPrice(storage) {
    return ref(storage.price - storage.discount).value
  }

  // NEW: Get detailed storage booking status
  function getStorageBookingStatus(storageId) {
    if (!storageId) return null

    const orderItems = store.getters.orderItemsEntries || []
    const storage = store.getters.storageById(Number(storageId))

    if (!storage) return null

    // Find active booking for this storage
    const activeBooking = orderItems.find(item => {
      const itemStorageId = item.storage_id || (item.storage && item.storage.id)
      return itemStorageId === Number(storageId) && !item.moveOutDate
    })

    // Check if storage is reserved
    const isReserved = storage.storageReservation === true

    const baseStatus = {
      storageId: Number(storageId),
      storageName: storage.name,
      location: storage.location,
      isReserved,
      hasActiveBooking: !!activeBooking
    }

    if (activeBooking) {
      // Get order information if available
      const order = store.getters.orderEntries.find(o => o.id === activeBooking.order_id)

      return {
        ...baseStatus,
        status: 'booked',
        isAvailable: false,
        activeBooking: {
          orderItemId: activeBooking.id,
          orderId: activeBooking.order_id,
          customer: order?.customer || null,
          rentStart: activeBooking.rentStart,
          rentEnd: activeBooking.rentEnd,
          price: activeBooking.price,
          discount: activeBooking.discount
        }
      }
    }

    if (isReserved) {
      return {
        ...baseStatus,
        status: 'reserved',
        isAvailable: false,
        reservationInfo: {
          message: 'Lagereinheit ist systemseitig reserviert'
        }
      }
    }

    return {
      ...baseStatus,
      status: 'available',
      isAvailable: true
    }
  }

  // NEW: Get all booked storage IDs for quick lookups
  function getBookedStorageIds() {
    const orderItems = store.getters.orderItemsEntries || []
    const bookedIds = new Set()

    orderItems.forEach(item => {
      if (!item.moveOutDate) {
        const storageId = item.storage_id || (item.storage && item.storage.id)
        if (storageId) {
          bookedIds.add(Number(storageId))
        }
      }
    })

    return Array.from(bookedIds)
  }

  // NEW: Check if any storages in a list are currently booked
  function hasAnyBookedStorage(storageIds) {
    if (!storageIds || storageIds.length === 0) return false

    const bookedIds = getBookedStorageIds()
    return storageIds.some(id => bookedIds.includes(Number(id)))
  }

  // NEW: Get booking conflicts for a list of storage IDs
  function getBookingConflicts(storageIds) {
    if (!storageIds || storageIds.length === 0) return []

    const conflicts = []

    storageIds.forEach(storageId => {
      const status = getStorageBookingStatus(storageId)

      if (status && !status.isAvailable) {
        conflicts.push({
          storageId: Number(storageId),
          storageName: status.storageName,
          status: status.status,
          reason: status.status === 'booked' ? 'Bereits vermietet' : 'Reserviert',
          booking: status.activeBooking || null
        })
      }
    })

    return conflicts
  }

  // NEW: Validate storage availability for booking
  function validateStorageAvailability(storageIds) {
    const validation = {
      valid: true,
      conflicts: [],
      availableStorages: [],
      message: ''
    }

    if (!storageIds || storageIds.length === 0) {
      validation.valid = false
      validation.message = 'Keine Lagereinheiten ausgewählt'
      return validation
    }

    const conflicts = getBookingConflicts(storageIds)
    validation.conflicts = conflicts

    if (conflicts.length > 0) {
      validation.valid = false
      validation.message = `${conflicts.length} von ${storageIds.length} Lagereinheiten sind nicht verfügbar`
    } else {
      validation.availableStorages = storageIds.map(id => {
        const storage = store.getters.storageById(Number(id))
        return {
          id: Number(id),
          name: storage?.name || `Lager ${id}`,
          location: storage?.location
        }
      })
      validation.message = `Alle ${storageIds.length} Lagereinheiten sind verfügbar`
    }

    return validation
  }

  return {
    isStorageBooked,
    isStorageBookedBack,
    isStorageRented,
    countOfRentedStorages,
    countOfNotRentedStorages,
    countOfRentedStoragesinLocation,
    countOfNotRentedStoragesinLocation,
    getStorageSumPrice,
    // NEW enhanced methods
    getStorageBookingStatus,
    getBookedStorageIds,
    hasAnyBookedStorage,
    getBookingConflicts,
    validateStorageAvailability,
  }
}
